import { _ as _getNative } from './_getNative.mjs';

var getNative = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

var _nativeCreate = nativeCreate;

export { _nativeCreate as _ };
